module.exports = __webpack_public_path__ + "img/P150T_weapon_30.b6497aab.png";